import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "./Navbar.css";

function NavScroll() {
  return (
    <Navbar bg="dark" expand="lg">
      <Container fluid>
        <Navbar.Brand
          style={{ color: "white", fontWeight: "bolder" }}
          href="/"
          className="navItem"
        >
          KAI TSZ TECHNOLOGY
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0"
            style={{ maxHeight: "150px", textAlign: "center" }}
            navbarScroll
          >
            <Nav.Link href="/" className="navItem" id="home">
              Home
            </Nav.Link>
            <Nav.Link href="about-us" className="navItem">
              About Us
            </Nav.Link>
            <NavDropdown
              title="Solutions"
              className="navItem"
              id="navbarScrollingDropdown"
            >
              <NavDropdown.Item href="web-development">
                Web Design & Development
              </NavDropdown.Item>
              <NavDropdown.Item href="app-development">
                Mobile App Design Development
              </NavDropdown.Item>
              {/* <NavDropdown.Divider />
                            <NavDropdown.Item href="#action5">
                                Something else here
                            </NavDropdown.Item> */}
            </NavDropdown>
            <Nav.Link href="contact-us" className="navItem">
              Contact Us
            </Nav.Link>
          </Nav>
          {/* <Form className="d-flex">
                        <Form.Control
                            type="search"
                            placeholder="Search"
                            className="me-2"
                            aria-label="Search"
                        />
                        <Button variant="outline-success">Search</Button>
                    </Form> */}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavScroll;
